module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vurin15-ff81e4932816e0401cccf1fcc7106597.jpg";